import Helpers from './Helpers.js';
import countries from './countries.js';
import us_states from './us-states.js';
import canada_provinces from './canada-provinces.js';
import Vue from 'vue';
import VeeValidate, { Validator } from 'vee-validate';

require('es6-promise').polyfill();

Vue.use(VeeValidate, {
    locale: 'en',
    classes: true,
    classNames: {
        // valid: 'is-valid',
        invalid: 'is-invalid'
    },
    // events: 'change',
    events: 'input|blur',
});

var isSuccess = (window.location.search.indexOf('?success') !== -1);

const app = new Vue({
    components: {
        
    },
    data: {
        env: window.env || 'live', // 'live' or 'test'
        formAction: window.formAction,
        showForm: !isSuccess,
        showFormSuccess: isSuccess,
        form: {
            first_name: '',
            last_name: '',
            email: '',
            phone: '',
            company: '',
            job_title: '',
            country: '',
            state: '',
        },
        countries,
        us_states,
        canada_provinces,
        allowFormSend: true,
        testForm: false,
        errorEmailFreeDomain: false,
    },

    watch: {
        'form.email'() {
            this.errorEmailFreeDomain = false;
        },
    },

    methods: {
        submitForm() {
            var $this = this;
            var form = $('#form-pardot');

            $this.errorEmailFreeDomain = false;
            this.$validator.validate().then(valid => {
                if (valid && $this.allowFormSend) {
                    $this.allowFormSend = false;
                    $.ajax({
                        url: window.formAction,
                        method: 'post',
                        data: form.serialize(),
                        success(data) {
                            // console.log(data);
                            if (data === 'error') {
                                $this.errorEmailFreeDomain = true;
                                return false;
                            }
                            $this.showForm = false;
                            $this.showFormSuccess = true;
                            $.ajax({
                                url: 'https://firemon.kubis.ro/state-of-the-firewall',
                                method: 'post',
                                data: form.serialize() + '&env=' + $this.env,
                                complete(req) {
                                    // console.log('complete: ', req);
                                    window.location.href = window.location.origin + window.location.pathname + '?success';
                                }
                            });
                        },
                        complete(req) {
                            // console.log(req);
                            $this.allowFormSend = true;
                        }
                    });
                }
            });
        },
    },

    mounted () {
        var $this = this;

        if (this.testForm) {
            this.form.first_name = 'test';
            this.form.last_name = 'last name';
            this.form.email = 'tudor.sava@kubisinteractive.com';
            this.form.phone = '0740111222';
            this.form.company = 'Kubis';
            this.form.job_title = 'web dev';
            this.form.country = 'Canada';
        }

        this.$nextTick(() => {

            if (isSuccess) {
                let pdfFileURL = ($this.env === 'live') ? 'https://go.pardot.com/l/11772/2019-02-08/5wyqs3/11772/215022/state_of_the_firewall_2018_2.pdf' : 'https://go.pardot.com/l/617471/2019-02-05/5l28xb/617471/216855/STATE_OF_THE_FIREWALL_2018_INSIGHTS_ANALYSIS_AND_ACTIONS.pdf';
                window.location.href = pdfFileURL;
            }

            $('.slider-facts').slick({
                infinite: true,
                arrows: true,
                dots: false,
                speed: 300,
                slidesToShow: 1,
                slidesToScroll: 1,
                adaptiveHeight: false,
                autoplay: true,
                autoplaySpeed: 5000,
                pauseOnFocus: false,
                pauseOnHover: true,
                responsive: [
                    {
                        breakpoint: 1200,
                        settings: {
                            adaptiveHeight: true,
                            autoplay: false,
                        }
                    },
                ],
            });
        });

    },
}).$mount('#app');


// WEBPACK FOOTER //
// ./resources/assets/js/app-state-of-the-firewall.js